import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref (not state) for processed flag to survive StrictMode double-call.
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }

    const tausch = async (versuch = 1) => {
      try { return await api.post('/auth/emergent-callback', { session_id: sessionId }, { timeout: 25000 }); } catch (e) {
        const vorbei = e?.response && e.response.status < 500;
        if (vorbei || versuch >= 4) throw e;
        await new Promise((r) => setTimeout(r, 1500 * versuch));
        return tausch(versuch + 1);
      }
    };
    (async () => {
      try {
        const { data } = await tausch();
        if (data?.two_factor_required) { window.history.replaceState(null, '', window.location.pathname); navigate('/login', { replace: true, state: { pending2fa: data.pending_token } }); return; }
        if (setUser && data?.user) setUser(data.user);
        // Clean URL hash
        window.history.replaceState(null, '', window.location.pathname);
        // Honor next path set by Login.jsx before OAuth redirect
        let next = '/dashboard';
        try {
          const stored = sessionStorage.getItem('post_login_next');
          if (stored) { next = stored; sessionStorage.removeItem('post_login_next'); }
        } catch (err) { console.warn('[auth-callback] sessionStorage nicht verfügbar', err); }
        navigate(next, { replace: true, state: { user: data.user } });
      } catch (e) {
        window.history.replaceState(null, '', window.location.pathname);
        const st = e?.response?.status;
        const eigene = st && st < 500 && typeof e.response.data?.detail === 'string' ? e.response.data.detail : '';
        try { sessionStorage.setItem('oauth_error', eigene || 'SERVER_NICHT_ERREICHBAR'); } catch (err) { /* ignore */ }
        navigate('/login?error=oauth_failed', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f5f8fa]">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-[#b8893d] animate-spin mx-auto mb-4" />
        <p className="text-[#1B3A5C] font-medium">Anmeldung wird abgeschlossen...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
